import React from 'react'
import {Route, Switch} from 'react-router'
import LoginPage from './containers/LoginPage'
import HomePage from './containers/HomePage'
import UsersPage from './containers/UsersPage'
import UserDetailPage from './containers/UserDetailPage'
import UserEditPage from './containers/UserEditPage'
import DogsPage from './containers/DogsPage'
import DogDetailPage from './containers/DogDetailPage'
import DogEditPage from './containers/DogEditPage'
import PartiesPage from './containers/PartiesPage'
import PartyDetailPage from './containers/PartyDetailPage'
import PartyEditPage from './containers/PartyEditPage'
import WalksPage from './containers/WalksPage'
import WalkDetailPage from './containers/WalkDetailPage'
import WalkEditPage from './containers/WalkEditPage'
import IntakesPage from "./containers/IntakesPage";
import EventsPage from "./containers/EventsPage";


export default (
	<Switch>
		{<Route exact path="/prihlaseni/:token?" component={LoginPage}/>}
		{<Route exact path="/uzivatele" component={UsersPage}/>}
		{<Route exact path="/uzivatele/novy" component={UserEditPage}/>}
		{<Route exact path="/uzivatele/:userId/uprava" component={UserEditPage}/>}
		{<Route exact path="/uzivatele/:userId/:tab?" component={UserDetailPage}/>}
		{<Route exact path="/vencitele" component={PartiesPage}/>}
		{<Route exact path="/vencitele/novy" component={PartyEditPage}/>}
		{<Route exact path="/vencitele/:partyId/uprava" component={PartyEditPage}/>}
		{<Route exact path="/vencitele/:partyId/:tab?" component={PartyDetailPage}/>}
		{<Route exact path="/psi" component={DogsPage}/>}
		{<Route exact path="/psi/novy" component={DogEditPage}/>}
		{<Route exact path="/psi/:dogId/uprava" component={DogEditPage}/>}
		{<Route exact path="/psi/:dogId/:tab?" component={DogDetailPage}/>}
		{<Route exact path="/vychazky" component={WalksPage}/>}
		{<Route exact path="/vychazky/nova/:partyId?" component={WalkEditPage}/>}
		{<Route exact path="/vychazky/:walkId/uprava" component={WalkEditPage}/>}
		{<Route exact path="/vychazky/:walkId/:tab?" component={WalkDetailPage}/>}
		{<Route exact path="/prijmy" component={IntakesPage}/>}
		{<Route exact path="/ukony" component={EventsPage}/>}
		{<Route exact path="/" component={HomePage}/>}
	</Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js